import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@mantine/core'

const ForbiddenPage: React.FC = () => {
  const history = useHistory()

    return (
        <div className="flex flex-col items-center justify-center min-h-screen gap-4">
              <h1 className="text-6xl font-bold text-red-500">403</h1>
                    <p className="text-xl text-gray-600">
                            You do not have permission to access this page.
                                  </p>
                                        <Button onClick={() => history.push('/')}>Go to Dashboard</Button>
                                            </div>
                                              )
                                              }

                                              export default ForbiddenPage
                                              